import React from "react";

const NotFoundPage = () => {
  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <h1 style={styles.code}>404</h1>
        <p style={styles.message}>Oops! The page you're looking for doesn’t exist.</p>
        <a href="https://www.knowledge-sun.com" style={styles.button}>
          Go to Homepage
        </a>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    minHeight: "100vh",
    backgroundColor: "#FB8C00", // orange.shade500
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "'Segoe UI', sans-serif",
    padding: "20px",
  },
  card: {
    backgroundColor: "#fff", // cardTheme: white
    borderRadius: "16px",
    padding: "40px",
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
    textAlign: "center",
    maxWidth: "480px",
    width: "100%",
  },
  code: {
    fontSize: "6rem",
    fontWeight: "bold",
    color: "#000", // black
    marginBottom: "20px",
  },
  message: {
    fontSize: "1.25rem",
    color: "#333",
    marginBottom: "30px",
  },
  button: {
    display: "inline-block",
    backgroundColor: "#FFC107", // amberAccent
    color: "#000",
    padding: "12px 28px",
    borderRadius: "8px",
    textDecoration: "none",
    fontWeight: "600",
    fontSize: "1rem",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease",
  },
};

export default NotFoundPage;
